/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempChevronsMenuLeftSmall: {
  name: 'temp-chevrons-menu-left-small';
  data: string;
} = {
  name: 'temp-chevrons-menu-left-small',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M10 11V5L6 8l4 3Z" fill="currentColor"/></svg>`,
};
